import { RegistrationProgress } from '@/components/ProgressBar/RegistrationProgress'
import api from '@/services/api'
import useAccessStore from '@/store/accessStore'
import { API_ENDPOINTS } from '@/utils/apiEndpoints'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useBrandUserStore from '../../store/brandUserStore'
import useInfluencerStore from '../../store/influencerStore'
import RegistrationIndustriesForm from './RegistrationIndustriesForm'
import styles from './registration.module.css'

interface IndustryItem {
  id: string
  name: string
}

export const RegistrationIndustries = () => {
  const navigate = useNavigate()
  const setValue = useBrandUserStore((s) => s.setValue)
  const { brandData } = useAccessStore()

  const availableIndustries = useInfluencerStore((s) => s.availableIndustries) as IndustryItem[]
  const initialize = useInfluencerStore((s) => s.initialize)
  const isInitialized = useInfluencerStore((s) => s.isInitialized)

  const [selected, setSelected] = useState<string[]>([])

  useEffect(() => {
    if (!isInitialized) {
      void initialize()
    }
  }, [isInitialized, initialize])

  useEffect(() => {
    if (brandData?.industries && Array.isArray(brandData.industries)) {
      setSelected(brandData.industries)
      setValue('industries', brandData.industries)
    }
  }, [brandData, setValue])

  const handleChange = (ids: string[]) => {
    setSelected(ids)
    setValue('industries', ids)
  }

  const handleBack = async () => {
    await useAccessStore.getState().fetchBrandData()
    navigate('/registration/profile')
  }

  const handleNext = async () => {
    if (selected.length === 0 || selected.length > 3) return
    try {
      await api.post(API_ENDPOINTS.BRAND.REGISTER_STEP_TWO, {
        industries: selected,
      })
      await useAccessStore.getState().fetchBrandData()
      navigate('/registration/business')
    } catch (error) {
      console.error('Failed to submit industries step:', error)
    }
  }

  return (
    <>
      <div className={styles.mainContentWrapper}>
        <h1 className={styles.title}>Industries</h1>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <RegistrationProgress />
        </div>

        <RegistrationIndustriesForm
          industries={availableIndustries}
          selected={selected}
          onChange={handleChange}
          onBack={handleBack}
          onNext={handleNext}
        />
      </div>
    </>
  )
}
